import React, { useEffect, useRef, useState } from "react";

export default function TextCell({ value, column, readOnly, onCommit }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? "");
  const inputRef = useRef(null);

  useEffect(() => {
    setDraft(value ?? "");
  }, [value]);

  useEffect(() => {
    if (editing) inputRef.current?.focus();
  }, [editing]);

  const commit = () => {
    setEditing(false);
    if ((draft || "") !== (value || "")) {
      onCommit(draft === "" ? null : draft);
    }
  };

  if (editing && !readOnly) {
    return (
      <input
        ref={inputRef}
        className="cell-input"
        value={draft ?? ""}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") commit();
          if (e.key === "Escape") {
            setDraft(value ?? "");
            setEditing(false);
          }
        }}
      />
    );
  }

  return (
    <div
      className={`cell-display text ${readOnly ? "read-only" : ""}`}
      onClick={() => !readOnly && setEditing(true)}
      title={column?.title}
    >
      {value || <span className="placeholder">—</span>}
    </div>
  );
}
